import { render, staticRenderFns } from "./Patreon.vue?vue&type=template&id=3cbc9e18&scoped=true"
import script from "./Patreon.vue?vue&type=script&lang=js"
export * from "./Patreon.vue?vue&type=script&lang=js"
import style0 from "./Patreon.vue?vue&type=style&index=0&id=3cbc9e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbc9e18",
  null
  
)

export default component.exports